<template>
  <div class="p-4">
    <div class="mb-4">Información banner</div>
    <BaseForm
      :formElements="formElements"
      @form:onSubmit="value => updateBanner(value)"
      :isLoading="isLoading"
    >
      <template #elements>
        <BaseFormElement
          :key="key"
          v-for="(element, key) in formElements"
          :elements="formElements"
          :element="element"
          v-model="element.data.value"
        >
          <template #after>
            <component :is="element.after" />
          </template>
        </BaseFormElement>
      </template>
    </BaseForm>
  </div>
</template>

<script>
import { ref, computed, watch } from 'vue'
import BaseForm from '@/components/form/BaseForm.vue'
import BaseFormElement from '@/components/form/BaseFormElement.vue'
import { formElements as BannerFormElements } from '@/config/BannerFormElements.ts'
import syncValues from '@/utils/syncValues.ts'

// Banner store
import { BANNER_STORE_NAME } from '@/store/modules/banner'
import { UPDATE_BANNER } from '@/store/modules/banner/actions.type'

// Notifications store
import { NOTIFICATIONS_STORE_NAME } from '@/store/modules/notifications'
import { PUSH_NOTIFICATION } from '@/store/modules/notifications/actions.type'

import { useStore } from 'vuex'
export default {
  components: {
    BaseForm,
    BaseFormElement
  },
  setup() {
    const store = useStore()
    const formElements = ref(BannerFormElements)
    const bannerData = computed(
      () => store.getters[BANNER_STORE_NAME + '/data']
    )
    const isLoading = computed(
      () => store.getters[BANNER_STORE_NAME + '/isLoading']
    )
    const isError = computed(
      () => store.getters[BANNER_STORE_NAME + '/isError']
    )
    const isReady = computed(
      () => store.getters[BANNER_STORE_NAME + '/isReady']
    )

    watch(bannerData, bannerData => {
      if (bannerData) {
        formElements.value = syncValues(formElements.value, bannerData)
      }
    })
    if (bannerData.value) {
      formElements.value = syncValues(formElements.value, bannerData.value)
    }
    async function updateBanner(data) {
      await store.dispatch(BANNER_STORE_NAME + '/' + UPDATE_BANNER, data)
      if (isReady.value) {
        pushNotification({
          title: 'Aplicado correctamente!',
          desciption:
            'Tu informacion relacionada con el Banner se ha actualizado ',
          type: 'success'
        })
      }
      if (isError.value) {
        pushNotification({
          title: 'Algun error ha ocurrido!',
          desciption: 'Vuelve a intentarlo o contacta a soporte',
          type: 'error'
        })
      }
    }

    function pushNotification(data) {
      store.dispatch(NOTIFICATIONS_STORE_NAME + '/' + PUSH_NOTIFICATION, data)
    }

    return {
      isLoading,
      updateBanner,
      formElements
    }
  }
}
</script>
